export function getApplicablePrice({
  priceList,
  selectedUomId, // 🔑 required
  sPriceListId,
  businessDate = new Date(),
}) {
  if (!Array.isArray(priceList) || priceList.length === 0) return null;

  const today = new Date(businessDate);
  today.setHours(0, 0, 0, 0);

  // 1️⃣ Filter by price list
  let filtered = priceList.filter((p) => p.sPricelistId === sPriceListId);

  if (filtered.length === 0) return null;

  // 🔁 Backward compatibility
  if (filtered.length === 1 && !filtered[0].uomId && !filtered[0].effectiveFrom) {
    return filtered[0];
  }

  // 2️⃣ UOM matching (STRICT)
  let uomFiltered = filtered.filter((p) => (p.uomId ? p.uomId === selectedUomId : true));

  // 3️⃣ Date-based pricing
  const dated = uomFiltered
    .filter((p) => p.effectiveFrom)
    .map((p) => ({
      ...p,
      effectiveDate: new Date(p.effectiveFrom),
    }))
    .filter((p) => p.effectiveDate <= today);

  if (dated.length > 0) {
    dated.sort((a, b) => b.effectiveDate - a.effectiveDate);
    return dated[0];
  }

  // 4️⃣ Fallback: UOM price without effective date
  const uomNoDate = uomFiltered.find((p) => !p.effectiveFrom && p.uomId === selectedUomId);
  if (uomNoDate) return uomNoDate;

  // 5️⃣ Final fallback: legacy default price
  return uomFiltered.find((p) => !p.effectiveFrom && !p.uomId) || null;
}
